var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseIcon05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white",
    fillOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 76,
    height: 76,
    rx: 38,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9392 55.278C48.2179 55.278 54.9291 48.5668 54.9291 40.288C54.9291 32.0093 48.2179 25.2981 39.9392 25.2981C31.6604 25.2981 24.9492 32.0093 24.9492 40.288C24.9492 48.5668 31.6604 55.278 39.9392 55.278Z",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1499 55.278C44.1893 55.278 47.4638 48.5668 47.4638 40.288C47.4638 32.0093 44.1893 25.2981 40.1499 25.2981C36.1105 25.2981 32.8359 32.0093 32.8359 40.288C32.8359 48.5668 36.1105 55.278 40.1499 55.278Z",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4023 33.8408H53.1364",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7344 45.0825H53.9642",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9414 10.074V22.5739",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1412 18.7231L52.2734 27.5909",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9402 39.9231H57.4414",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9993 60.9845L52.3047 52.2888",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8477 69.7024V57.2891",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8008 60.9295L27.5091 52.2212",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1094 39.9231H22.643",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.957 18.739L27.8438 27.6247",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7734 13.0159L39.9422 9.80493L43.2187 12.7584",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4336 18.6419L61.3799 18.5005L61.1456 23.0014",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7344 36.4775L70.508 39.9229L66.7344 43.1919",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1944 56.5754L61.4889 61.1777L56.6523 60.9328",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0136 66.2253L39.848 70.1953L36.5938 66.2253",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1496 61.1775L18.4102 61.3739V56.228",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4125 43.1434L9.49219 39.9229L13.4125 36.3794",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9502 23.3929L18.5586 18.1003L23.6548 18.5004",
    stroke: "#34CDFA",
    strokeWidth: 1.26667,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseIcon05);
export default __webpack_public_path__ + "static/media/choose_icon05.d6eb1dcf9c51115e307398ad590f35c0.svg";
export { ForwardRef as ReactComponent };